import React, { useEffect } from 'react';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Spinner } from '../../../components';

interface DeactivatePlanModalProps {
  isOpen: boolean;
  planName: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const DeactivatePlanModal: React.FC<DeactivatePlanModalProps> = ({
  isOpen,
  planName,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !isLoading) onClose();
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, isLoading, onClose]);

  if (!isOpen) return null;

  return (
    <div className="subscription-modal" role="presentation">
      <div
        className="subscription-modal__overlay"
        onClick={isLoading ? undefined : onClose}
        aria-hidden="true"
      />

      <div
        className="subscription-modal__dialog subscription-modal__dialog--confirm"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="deactivate-plan-title"
      >
        <span className="subscription-modal__warning-icon" aria-hidden="true">
          <ExclamationTriangleIcon />
        </span>

        <h2 id="deactivate-plan-title">Deactivate Plan?</h2>
        <p>
          Are you sure you want to deactivate the {planName}? This action will prevent new
          sign-ups and may affect existing automated billing cycles.
        </p>

        <div className="subscription-modal__footer subscription-modal__footer--confirm">
          <button
            type="button"
            className="subscription-modal__btn subscription-modal__btn--ghost"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="subscription-modal__btn subscription-modal__btn--danger"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? <Spinner size="small" /> : null}
            {isLoading ? 'Deactivating...' : 'Confirm Deactivation'}
          </button>
        </div>
      </div>
    </div>
  );
};
